import { i18n } from 'core/i18n'

const { FormattedText } = i18n

export const InformationContent = () => {
    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-xs-12">
                    <h4 className="accountCancelModal-title">
                        <FormattedText value="cancellation_account-cancellation_account_pre_information_modal_title" />
                    </h4>
                </div>
            </div>
            <div className="row">
                <div className="col-xs-12">
                    <p>
                        <FormattedText value="cancellation_account-cancellation_account_pre_information_modal_subtitle" />
                    </p>
                    <div className='accountCancelModal__recomendation-list'>
                        <FormattedText value="cancellation_account-cancellation_account_pre_information_modal_recomendations_bullets" />
                    </div>
                    <p><FormattedText value="cancellation_account-cancellation_account_pre_information_modal_contact_info" /></p>
                </div>
            </div>
        </div>
    )
}
